<template>
    <div>
        <div class="md-layout">
            <adjustment-create-new-Component
                v-if="adjustmentDetails.isEditing === false"
                :adjustment-details="adjustmentDetails"
                :team-members="teamMembers"
                :customers="customers"
            />

            <div class="md-layout-item md-size-50 tripdate-container">
                <md-datepicker v-model="adjustmentDetails.tripDate" md-immediately :md-debounce="10">
                    <label>Adjustment Date</label>
                </md-datepicker>
            </div>

            <div class="md-layout-item md-size-50 amount-container">
                <div class="amount-switch-container custom-switch-blue">
                    <md-switch
                        v-model="adjustmentDetails.adjustmentIsPercentage"
                        class="amount-switch"
                        @change="handlePercentageChange"
                    />
                </div>
                <form-group
                    v-show="!adjustmentDetails.adjustmentIsPercentage"
                    name="amount"
                    label="Amount"
                    attribute="Amount"
                >
                    <span v-if="adjustmentDetails.amount" class="currency-container">
                        {{ null | currency(user.teamCurrency, true) }}
                    </span>
                    <md-input v-model.number="adjustmentDetails.amount" required type="number" />
                </form-group>

                <form-group
                    v-show="adjustmentDetails.adjustmentIsPercentage"
                    name="percentageAmount"
                    label="Percentage"
                    attribute="Percentage"
                >
                    <md-input v-model.number="adjustmentDetails.percentageAmount" required type="number" />
                    <md-tooltip md-direction="top">{{ $t('invoicing.adjustments.percentageTooltip') }}</md-tooltip>
                </form-group>
            </div>

            <div class="md-layout-item md-size-50">
                <form-group name="invoiceAdjustmentCategory" label="Category" attribute="Category">
                    <md-input v-model="adjustmentDetails.invoiceAdjustmentCategory" type="hidden" />
                    <vue-select
                        label="category"
                        :options="categoryList"
                        v-model="adjustmentDetails.invoiceAdjustmentCategory"
                        :append-to-body="true"
                    ></vue-select>
                </form-group>
            </div>

            <div class="md-layout-item md-size-50">
                <form-group name="description" label="Description" attribute="Description">
                    <md-input v-model="adjustmentDetails.description" />
                </form-group>
            </div>

            <div class="md-layout-item md-size-100 account-code-description-container">
                <account-code-description-group
                    :account-code="adjustmentDetails.accountCode"
                    :account-code-description="adjustmentDetails.accountCodeDescription"
                    :is-update="true"
                    :account-code-type="accountCodeType"
                    :account-code-container-class="'md-layout-item md-size-50'"
                    :account-code-description-container-class="'md-layout-item md-size-50'"
                    :parent-container-class="'md-layout'"
                    @optionSelected="handleAccountCodeChanged"
                    @optionDescriptionSelected="handleAccountDescriptionChanged"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccountCodeDescriptionGroup from '../../../../components/AccountCodeDescriptionGroup';
import AdjustmentCreateNewComponent from './AdjustmentCreateNewComponent';

export default {
    name: 'AdjustmentDetailsStep',
    props: {
        adjustmentDetails: {
            type: Object,
            default: () => {}
        },
        categories: {
            type: Array,
            default: () => []
        },
        teamMembers: {
            type: Array,
            default: () => []
        },
        customers: {
            type: Array,
            default: () => []
        }
    },
    components: {
        AdjustmentCreateNewComponent,
        AccountCodeDescriptionGroup
    },
    watch: {
        'adjustmentDetails.isDriver': function(newVal, oldVal) {
            if (this.adjustmentDetails.isDriver) {
                this.categoryList = this.categories.filter((x) => x.isTeamMember);
                this.accountCodeType = 'expense';
            }
        },
        'adjustmentDetails.isCustomer': function(newVal, oldVal) {
            if (this.adjustmentDetails.isCustomer) {
                this.categoryList = this.categories.filter((x) => x.isCustomer);
                this.accountCodeType = 'income';
            }
        }
    },
    methods: {
        handlePercentageChange() {
            this.adjustmentDetails.amount = null;
            this.adjustmentDetails.percentageAmount = null;
        },
        handleAccountCodeChanged(accountCode) {
            this.adjustmentDetails.accountCode = accountCode;
        },
        handleAccountDescriptionChanged(accountCodeDescription) {
            this.adjustmentDetails.accountCodeDescription = accountCodeDescription;
        }
    },
    data() {
        return {
            categoryList: [],
            adjustmentIsPercentage: false,
            accountCodeType: null
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/md/_colors.scss';

.modal-container .modal-body .md-card .md-card-content .md-size-50:last-child {
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.modal-container .modal-body .md-card .md-card-content .md-size-50:first-child {
    padding-right: 15px !important;
    padding-left: 10px !important;
}

.account-code-description-container {
    padding: 0 !important;
}

::v-deep .vs__selected {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-wrap: nowrap;
    color: white;
    background-color: #41b883;
}

.tripdate-container .div .button {
    background-color: transparent !important;
}

.amount-container {
    display: flex;
    flex-direction: row-reverse;
}

.amount-switch {
    position: fixed !important;
    z-index: 10;
}

.amount-switch-container {
    display: contents;
}

.currency-container {
    padding-top: 7px;
    margin-right: 4px;
    cursor: text !important;
}
</style>
